import React, { useState } from "react";
import { useNotaire } from "../../context/NotaireContext";
import { Fieldset, Legend } from "../../components/catalyst/fieldset";
import { toast } from "react-toastify";

const COMPETENCES_LIST = [
  "Droit de l'immobilier",
  "Succession",
  "Fiscalité & gestion de patrimoine",
  "Droit de l'entreprise",
  "Droit de la famille",
];

function PanelCompetences() {
  const context = useNotaire();
  const [competences, setCompetences] = useState(context.infoNotaire.domaine_competences || []);
  const [loading, setLoading] = useState(false);

  const handleCheck = (event) => {
    const { value, checked } = event.target;
    setCompetences((prev) =>
      checked ? [...prev, value] : prev.filter((val) => val !== value)
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(
        `https://api.airtable.com/v0/appD48APNaGA4GN0B/info-notaire/${context.infoNotaire.id}`,
        {
          method: "PATCH",
          headers: {
            Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ fields: { domaine_competences: competences } }),
        }
      );

      if (res.ok) {
        toast.success("Compétences mises à jour !");
      } else {
        const errText = await res.text();
        console.error("Erreur Airtable :", errText);
        toast.error("Erreur lors de la mise à jour.");
      }
    } catch (err) {
      console.error("Erreur réseau :", err);
      toast.error("Erreur réseau");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow mt-8">
      <Fieldset>
  <Legend>Vos domaines de compétences</Legend>

  <div className="flex flex-wrap gap-2 mt-2">
    {COMPETENCES_LIST.map((comp) => {
      const isSelected = competences.includes(comp);

      return (
        <label
  key={comp}
  className={`
    flex items-center gap-1.5
    cursor-pointer px-3 py-1.5 rounded-full text-sm font-medium transition-all duration-150
    border
    ${
      isSelected
        ? "bg-indigo-600 text-white border-indigo-600"
        : "bg-gray-100 text-gray-700 border-gray-200 hover:bg-indigo-50 hover:border-indigo-300"
    }
  `}
>
  <input
    type="checkbox"
    value={comp}
    checked={isSelected}
    onChange={handleCheck}
    className="hidden"
  />

  {/* ✅ Check */}
  {isSelected && (
    <span className="text-white text-xs">✔</span>
  )}

  <span>{comp}</span>
</label>
      );
    })}
  </div>
</Fieldset>

      <button type="submit" className="btn-primary mt-4" disabled={loading}>
        {loading ? "Mise à jour..." : "Modifier les compétences"}
      </button>
    </form>
  );
}

export default PanelCompetences;